import { ElementRef, Renderer2 } from '@angular/core';
import { PopupDraggableDirective } from '../directives/popup-draggable.directive';

export function setupPopupDraggable(
  renderer: Renderer2,
  elementRef: ElementRef,
  popupName: string,
  isHeaderDrag?: boolean
): (() => void)[] {
  const eventListeners: (() => void)[] = [];

  const popupElement = elementRef.nativeElement.parentElement.parentElement.parentElement?.querySelector(
    `.${popupName}`
  );

  const headerElement = elementRef.nativeElement.parentElement.parentElement.parentElement?.querySelector(
    `.${popupName} .c-modal-header`
  );

  if (popupElement) {
    const directive = new PopupDraggableDirective(new ElementRef(popupElement));
    directive.popupDraggable = popupElement;

    if (headerElement && isHeaderDrag) {
      // Attach mousedown to headerElement only, but mousemove and mouseup to document
      eventListeners.push(
        renderer.listen(headerElement, 'mousedown', (event) =>
          directive.onMouseDown(event)
        )
      );
      eventListeners.push(
        renderer.listen('document', 'mousemove', (event) =>
          directive.onMouseMove(event)
        )
      );
      eventListeners.push(
        renderer.listen('document', 'mouseup', () => directive.onMouseUp())
      );
    } else {
      eventListeners.push(
        renderer.listen(popupElement, 'mousedown', (event) =>
          directive.onMouseDown(event)
        )
      );
      eventListeners.push(
        renderer.listen('document', 'mousemove', (event) =>
          directive.onMouseMove(event)
        )
      );
      eventListeners.push(
        renderer.listen('document', 'mouseup', () => directive.onMouseUp())
      );
    }

    return eventListeners;
  }

  return [];
}
